import store from './store'
import { getToken } from '@/utils/auth' // getToken from cookie
import { menuData } from '@/api/config'
import router from '@/router'

// 页面类型  消息，账户中心 ，首页, hro  这几个类型会记录type值 点击商家中心时回到对应的页面
const pageTypeData = ['notice', 'accountCenter', 'index']

router.beforeEach((to, from, next) => {
  if (pageTypeData.indexOf(to.meta.type) === -1) {
    // 商家中心按钮
    sessionStorage.setItem('pageType', (to.meta.type) || 'crowdSourcingServices')
  }
  if (getToken()) {
    if (to.path === '/login') {
      const path = menuData[to.query.type || 'crowdSourcingServices'].path
      next({ path: path })
    } else {
      if (!store.getters.roles.length) {
        // 判断当前用户是否已拉取完user_info信息
        store.dispatch('GetInfo').then(res => { // 拉取user_info
          return store.dispatch('GenerateRoutes')
        }).then(() => {
          const roles = store.getters.roles

          if (!roles.length) {
            Notification({
              message: '当前账户未配置角色，请使用主账户为该账号分配角色',
              type: 'error',
              duration: 5 * 1000
            })
            store.dispatch('FedLogOut').then(() => {
              // Message.error('鉴权失败，请重新登录！')
              next({ path: '/login' })
            })
            return
          }
          const addRouters = store.getters.addRouters
          router.addRoutes(addRouters)
          const allRoutePath = Object.keys(store.getters.allRoutePath.hash)

          console.log('!allRoutePath.includes(to.path)', !allRoutePath.includes(to.path))
          if (!allRoutePath.includes(to.path)) {
            next({ path: allRoutePath[0], replace: true })
            return
          }
          next({ ...to, replace: true })
        }).catch(() => {
          store.dispatch('FedLogOut').then(() => {
            // Message.error('鉴权失败，请重新登录！')
            next({ path: '/' })
          })
        })
      } else {
        next()
      }
    }
  } else {
    if (to.meta && to.meta.isUnLogin) { // 在免登录白名单，直接进入
      next()
    } else {
      next({ path: '/login', query: { type: menuData[to.meta.type || 'crowdSourcingServices'].key } })
    }
  }
})

router.afterEach(() => {
})
